import { Batch } from '../../types'
import { stringify } from '../../utils'
import { Database } from '../database.types'

const DATABASE_NAME_SPACE = 'SDK_PAYMENTS_EVENT_LOGS'
const MAX_STORED_ITEMS = 200

export class LocalStorage implements Database {
  #localStorage: Storage
  #databaseName: string
  #maxItems: number

  constructor(organizationName: string, databaseNameSpace?: string, maxItems = MAX_STORED_ITEMS) {
    this.#localStorage = window.localStorage
    this.#databaseName = `${databaseNameSpace || DATABASE_NAME_SPACE}_${organizationName}`
    this.#maxItems = maxItems

    const database = this.#localStorage.getItem(this.#databaseName)

    if (database === null || database === undefined) {
      this.reset()
    }
  }
  async reset(): Promise<void> {
    this.#localStorage.setItem(this.#databaseName, JSON.stringify([]))
  }

  #getDatabase(): Batch[] {
    let database = this.#localStorage.getItem(this.#databaseName)

    if (database === null || database === undefined) {
      database = JSON.stringify([])

      this.#localStorage.setItem(this.#databaseName, database)
    }

    return JSON.parse(database)
  }

  async setItem(item: Batch): Promise<void> {
    const database = this.#getDatabase()

    database.push(item)

    if (database.length > this.#maxItems) {
      database.splice(0, database.length - this.#maxItems)
    }

    this.#localStorage.setItem(this.#databaseName, stringify(database))
  }

  getItem(id: string): Promise<Batch> {
    throw new Error('Method not implemented.' + id)
  }
  removeItem(id: string): Promise<void> {
    throw new Error('Method not implemented.' + id)
  }

  getAllItems(): Promise<Batch[]> {
    const database = this.#getDatabase()
    this.reset()
    return Promise.resolve(database)
  }

  count(): number {
    const database = this.#getDatabase()

    return database.length
  }
}
